
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-clipboard-demo-xflow-components-clipboard"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.en.md?type=demo')
};